import React from 'react';

const Highlight = ({ text, highlight }) => {
  if (!highlight) return <>{text}</>;
  const regex = new RegExp(`(${highlight})`, 'gi');
  const parts = String(text).split(regex);
  return (
    <>
      {parts.map((part, i) =>
        part.toLowerCase() === highlight.toLowerCase() ? (
          <span key={i} style={{ background: '#ffe066', color: '#222' }}>
            {part}
          </span>
        ) : (
          part
        ),
      )}
    </>
  );
};

export default Highlight;
